import { Tag } from '@ardoq/status-ui';
import { AppliedSettingsRow } from './AppliedSettingsRow';
import { IconName } from '@ardoq/icons';
import { WithPopover } from '@ardoq/popovers';
import { FlexBox } from '@ardoq/layout';
import { LegacyLabelSetting } from './types';
import { PopoverListItem } from './PopoverListItem';
import { t, type I18nLocale } from '@ardoq/i18n';

type Props = {
  settings: LegacyLabelSetting;
  i18nLocale: I18nLocale;
};

export const LabelSettings = ({ settings, i18nLocale }: Props) => {
  const {
    referenceFormattingLabel,
    componentFormattingLabel,
    customLabelsCount,
    onEditClick,
  } = settings;

  const popoverContent = customLabelsCount
    ? () => (
        <FlexBox flexDirection="column" paddingLeft="small">
          <PopoverListItem
            text={`${t(i18nLocale, 'appLayout:componentLabelText', 'Component label:')} ${componentFormattingLabel?.label}`}
          />
          <PopoverListItem
            text={`${t(i18nLocale, 'appLayout:referenceLabelText', 'Reference label:')} ${referenceFormattingLabel?.label}`}
          />
        </FlexBox>
      )
    : null;

  const tag = [
    <WithPopover content={popoverContent} key="LabelFormattingTag">
      <Tag label={customLabelsCount.toString()} />
    </WithPopover>,
  ];

  return (
    <AppliedSettingsRow
      label={t(i18nLocale, 'appLayout:labelsLabel', 'Labels')}
      tags={tag}
      icon={IconName.TAG}
      onEditClick={onEditClick}
      isDisabled={!customLabelsCount}
      i18nLocale={i18nLocale}
    />
  );
};
